import React from 'react';
interface CTAButtonProps {
  children: ReactNode;
  className?: string;
}
export function CTAButton({
  children,
  className = ''
}: CTAButtonProps) {
  return <div className="relative inline-block w-full md:w-auto" data-id="element-82">
      <div className="absolute inset-0 bg-brand-green rounded-xl animate-ping opacity-20 scale-105" data-id="element-83"></div>
      <a href="https://jabonesartesanal.online/cart" className={`relative block w-full md:inline-flex md:w-auto items-center justify-center text-center bg-brand-dark-green text-white font-bold text-lg md:text-xl py-4 px-8 rounded-xl shadow-[0_8px_20px_rgba(45,90,61,0.3)] hover:shadow-[0_12px_25px_rgba(45,90,61,0.4)] hover:-translate-y-1 transition-all duration-300 ${className}`} data-id="element-84">
        {children}
      </a>
    </div>;
}